import { toLower } from 'lodash';
export const isServer = typeof window === 'undefined';

export const isStandAlonePage = (name: string) => toLower(name) === 'info';
